import { colombiaOptions, colombiaArrangedOptions } from '../countryOptions/colombiaOptions';
import { orderByLocale, removeDuplicatedObjectsByKey, removeExcludedField } from '../helpers';
import { generateInput } from '../../../../shared/utils/Form/useForm';

export const getColombiaSpecificOptions = (
  inputs: Array<Record<string, unknown>>,
  fields: Record<string, unknown>,
  onValuesChange: (newValue: unknown) => void,
  bankEntities: Array<Record<string, string>>
) => {
  const colombiaInputOptions = { ...colombiaOptions(bankEntities) };
  const inputsCopy = inputs;

  const withoutExcluded = removeExcludedField(inputsCopy, [colombiaInputOptions.exclude]);
  const inputOptions = [
    generateInput(onValuesChange, fields.documentType)(colombiaInputOptions.documentType),
    generateInput(onValuesChange, fields.personalId)(colombiaInputOptions.personalIdTypeInputOptions),
    generateInput(onValuesChange, fields.address)(colombiaInputOptions.addressInputOptions),
    generateInput(onValuesChange, fields.bankAccountType)(colombiaInputOptions.colombiaBankAccountTypeInputOptions),
    generateInput(onValuesChange, fields.bic_swift)(colombiaInputOptions.bicSwiftInputOptions),
    ...withoutExcluded
  ];

  const withoutDuplicatedObjects = removeDuplicatedObjectsByKey(inputOptions, 'name');
  const orderedInputOptions = orderByLocale(colombiaArrangedOptions, withoutDuplicatedObjects);

  return orderedInputOptions;
};
